// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__PKQa1","empty__status":"styles_empty__status__HbWFi"};